var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.head_items.length > 0
    ? _c("div", { staticClass: "kadru_inside" }, [
        _c("legend", [_vm._v("Кадри")]),
        _vm._v(" "),
        _c("div", { staticClass: "memorandum_info" }, [
          _c("div", { staticClass: "kadru_data" }, [
            _c(
              "div",
              { staticClass: "head" },
              [
                _vm._l(_vm.head_items, function (head_item) {
                  return _c(
                    "div",
                    { staticClass: "field", class: head_item.class },
                    [
                      _c("div", { staticClass: "title_min" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(head_item.name) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clr" }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "before_change" },
              [
                _c("div", { staticClass: "pre_title pl-0" }, [
                  _vm._v("До змін"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dpartm" }, [
                  _vm._v(_vm._s(_vm.department_before)),
                ]),
                _vm._v(" "),
                _vm.work_items.hasOwnProperty("before")
                  ? _c(
                      "div",
                      { staticClass: "fields_insert" },
                      [
                        _vm._l(_vm.work_items.before, function (field) {
                          return _c("kadr_field", {
                            key: "before_" + field.number,
                            attrs: { field: field },
                          })
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clr" }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.work_items.hasOwnProperty("before_total")
                  ? _c("kadr_field_total", {
                      key: "before_total",
                      attrs: { field: _vm.work_items.before_total },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "before_change" },
              [
                _c("div", { staticClass: "pre_title pl-0" }, [
                  _vm._v("Після змін"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dpartm" }, [
                  _vm._v(_vm._s(_vm.department_after)),
                ]),
                _vm._v(" "),
                _vm.work_items.hasOwnProperty("after")
                  ? _c(
                      "div",
                      { staticClass: "fields_insert" },
                      [
                        _vm._l(_vm.work_items.after, function (field) {
                          return _c("kadr_field", {
                            key: "after_" + field.number,
                            attrs: { field: field },
                          })
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clr" }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.work_items.hasOwnProperty("after_total")
                  ? _c("kadr_field_total", {
                      key: "after_total",
                      attrs: { field: _vm.work_items.after_total },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }